import React from 'react'
import './Industry3.css'
export default function Indusrty3() {
  return (
    <div>
       <div className="indusrty3-section">
              
      
              <div className="indusrty3-content-i">
         
          <div className="indusrty3-text">
            <h1 className="indusrty3-content-hh">Let's talk about your project</h1>
            <p>
            Leave a request - our managers will analyze your current situation and help you choose a site to scale your business


            </p>
          </div>
      
          {/* Button beside the text */}
          <button className="cta-button-indusrty3"> LET'S DISCUSS YOUR PROJECT<span className="arrow-indusrty3">🡥</span></button>
        </div>
      </div>
     
    </div>
    
  )
}
